export default __webpack_public_path__ + "static/hero-eset-cybersecurity-pro-01c8d7c2007992cb398a9e2f5b094c5d.png";